var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rmk-bg"},[_c('p',{staticClass:"text-center header-text"},[_vm._v("404")]),_c('p',{staticClass:"text-center body-text"},[_vm._v("Page Not Found")]),_c('p',{staticClass:"text-center"},[_c('b-button',{staticClass:"text-white m-4",attrs:{"variant":"primary","size":"lg","to":{ path: '/user' }}},[_vm._v("Bosh sahifa")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }